import { useState } from "react";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TableCell from "../../../../BillingAndPayments/components/TableCell";
import {
  AD_GROUP,
  VALUE_NUMBER,
  VALUE_WITH_CURRENCY_MANUAL_FORMAT,
  VALUE_WITH_PERCENTAGE,
} from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import TableContainer from "../../../../../components/Tables/TableContainer";
import TiktokAdRow from "./TiktokAdRow";
import { useFormContext } from "react-hook-form";
import { renderMetricValue } from "../../../../../utils/renderMetricValue";

const TiktokAdGroupRow = ({
  indexCampaign,
  adGroupID,
  indexAdGroup,
  data,
  adsStatistics,
  sortConfig,
  columns,
}) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslationApp();

  const { campaign, getCostByMainCurrency } = useFormContext();
  const adsGroups = campaign.adsGroups || [];
  const foundAdGroup = adsGroups.find((adGroup) => adGroup.id === adGroupID);

  const { cost, currency } = getCostByMainCurrency({
    cost: data.spend,
    currency: data.currency,
  });

  const { cost: costPerMainAction, currency: currencyPerMainAction } =
    getCostByMainCurrency({
      cost: data.costPerMainAction,
      currency: data.currency,
    });

  const sortedAds = Object.entries(adsStatistics).sort((a, b) => {
    const adData1 = a[1];
    const adData2 = b[1];
    if (sortConfig.key) {
      const comparison =
        (adData1[sortConfig.key] || 0) - (adData2[sortConfig.key] || 0);
      return sortConfig.direction === "asc" ? comparison : -comparison;
    }
    return 0;
  });

  return (
    <>
      <TableContainer
        hasPagination={false}
        rounded={false}
        hasMarginBottom={false}
        keys={[""]}
      >
        <TableRow>
          <TableCell
            indexRow={indexCampaign}
            sx={{ width: 25, pl: 5 }}
            level={2}
          >
            <IconButton size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          {columns.map((col) => (
            <TableCell
              key={col.key}
              indexRow={indexCampaign}
              level={2}
              sx={{ width: 192, maxWidth: 192, minWidth: 192 }}
            >
              {(() => {
                switch (col.key) {
                  case "platform":
                    return (
                      foundAdGroup?.name || `${t(AD_GROUP)} ${indexAdGroup + 1}`
                    );
                  case "spend":
                    return t(VALUE_WITH_CURRENCY_MANUAL_FORMAT, {
                      value: cost,
                      currency,
                    });
                  case "impressions":
                    return t(VALUE_NUMBER, { value: data.impressions });
                  case "click":
                    return t(VALUE_NUMBER, { value: data.click });
                  case "ctr":
                    return t(VALUE_WITH_PERCENTAGE, { value: data.ctr });
                  case "mainAction":
                    return t(VALUE_NUMBER, { value: data.mainAction });
                  case "costPerMainAction":
                    return renderMetricValue(
                      costPerMainAction,
                      col.key,
                      currencyPerMainAction
                    );
                  case "cpc":
                    return t(VALUE_WITH_CURRENCY_MANUAL_FORMAT, {
                      value: (data.cpc || 0).toFixed(2),
                      currency: data.currency,
                    });
                  case "cpm":
                    return t(VALUE_WITH_CURRENCY_MANUAL_FORMAT, {
                      value: (data.cpm || 0).toFixed(2),
                      currency: data.currency,
                    });
                  default:
                    return data[col.key];
                }
              })()}
            </TableCell>
          ))}
        </TableRow>
        <TableRow>
          <TableCell
            colSpan={columns.length + 1}
            indexRow={indexCampaign}
            sx={{ p: 0, borderBottom: "none", height: 0 }}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              {sortedAds.map(([adID, adData], indexAd) => {
                return (
                  <TiktokAdRow
                    key={adID}
                    indexCampaign={indexCampaign}
                    indexAdGroup={indexAdGroup}
                    adGroupID={adGroupID}
                    indexAd={indexAd}
                    adID={adID}
                    data={adData}
                    columns={columns}
                  />
                );
              })}
            </Collapse>
          </TableCell>
        </TableRow>
      </TableContainer>
    </>
  );
};

export default TiktokAdGroupRow;
